import { useTranslation } from 'react-i18next';

import { type EmojiCategory } from '@pkg/hooks';

import { assertAllResults } from './utilities';

export interface CategoryTitleOptions {
    category?: EmojiCategory;
    keywordFilter?: string;
}

export function useCategoryTitle({ category, keywordFilter }: CategoryTitleOptions) {
    const { t: translate } = useTranslation('emoji');

    return assertAllResults(category, keywordFilter) ? translate('allResults') : category;
}
